import React from "react";
import _ from "lodash";
import Modal from "../base/Modal";
import DomainSetupWizard from "./DomainSetupWizard";

function DomainSetupModal(props) {
  const { onHide, ...other } = props;
  const modalProps = _.pick(other, Modal.BASIC_PROPS);

  return (
    <Modal {...modalProps} size="small" onHide={onHide} backdrop="static">
      <Modal.Dialog>
        <Modal.Dialog.Header closeButton>
          <Modal.Dialog.Title>Domain Setup</Modal.Dialog.Title>
        </Modal.Dialog.Header>
        <Modal.Dialog.Body style={{ padding: 0, minHeight: "18.75rem" }}>
          <DomainSetupWizard onComplete={onHide} />
        </Modal.Dialog.Body>
      </Modal.Dialog>
    </Modal>
  );
}

export default DomainSetupModal;
